import React from "react"
import { Box, Switch, Typography } from "@mui/material"
import { AppAcrissAutocomplete } from "@components/Autocomplete"
import useAutoEuropeDataInfo from "Pages/AutoEuropeTool/Page/@hooks/useDataInfo"
import { autoEuropeDrawerData, autoEuropeOriginalData } from "Pages/AutoEuropeTool/Page/@signals"
import { enrichFilterIds } from "Pages/AutoEuropeTool/Page/@utils/filterEnrich"

export default function AutoEuropeFilterAcriss() {
	const d = autoEuropeDrawerData.peek()
	const { dataInfo: acrissInfo, setDataInfo: setAcriss } = useAutoEuropeDataInfo(d.filterAcriss ?? [])
	const { dataInfo: exclInfo, setDataInfo: setExcl } = useAutoEuropeDataInfo(d.filterAcrissExclusion ?? false)

	const isExclusion = exclInfo.value
	const acriss = acrissInfo.value ?? []

	return (
		<Box>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
				<Switch checked={isExclusion} onChange={e => setExcl(e.target.checked, 'filterAcrissExclusion')} size="small"/>
				<Typography variant="body2" sx={{ fontWeight: 500 }}>
					{isExclusion ? 'Exclude acriss' : 'Include acriss'}
				</Typography>
			</Box>
			<AppAcrissAutocomplete
				label={isExclusion ? 'Exclude Acriss' : 'Include Acriss'}
				placeholder={isExclusion ? 'No acriss excluded' : 'No acriss included'}
				value={acriss.map(o => o?.value ?? o)}
				onChange={(_, opts) => setAcriss(opts ?? [], 'filterAcriss')}
				onAjax={options => { enrichFilterIds('filterAcriss', options, autoEuropeDrawerData, autoEuropeOriginalData); return options }}
			/>
		</Box>
	)
}